import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../lib/auth-context.js';

type Row = Record<string, unknown>;

/**
 * Workfront object catalog — list of detected Workfront object types
 * + their custom forms for the caller's license. Sourced from
 * `/engine/v1/workfront-objects/catalog`.
 */
export function useWorkfrontObjectCatalog(): {
  data?: Row[];
  isLoading: boolean;
  error: Error | null;
} {
  const { session, api } = useAuth();
  const q = useQuery({
    queryKey: ['workfront', 'object-catalog', session?.licenseId ?? 'anon'],
    queryFn: () => api.get<{ data: Row[] }>('/v1/workfront/object-catalog').then((r) => r.data),
    enabled: !!session,
    staleTime: 5 * 60_000,
  });
  return { data: q.data, isLoading: q.isLoading, error: (q.error as Error) ?? null };
}
